var render = function render(_c,_vm){return _c('button',{staticClass:"btn",class:[_vm.data.staticClass, _vm.data.class, {'loading-btn': _vm.props.loading}],staticStyle:{"white-space":"nowrap"},attrs:{"disabled":_vm.props.disabled || _vm.props.loading,"readonly":_vm.props.readonly},on:{"click":function($event){_vm.listeners.click && _vm.listeners.click()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }